import axios from 'axios';
import { axiosToServiceResult } from '@shared/axios';
import type { Cartv2DetailsDisplayModel } from '@shared/models/carts/carts';

export const searchCart = async (orderNumber: string, email: string) =>
  await axiosToServiceResult(
    axios.get<Cartv2DetailsDisplayModel>(`/api/customer/cart/search/`, { params: { orderNumber, email } }),
  );
